var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isUsOnlyCompany)?_c('fin-well-banner'):_vm._e(),_c('div',{staticClass:"page-wrapper",attrs:{"id":"app"}},[_c('div',{staticClass:"page-inner"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }